import { render, staticRenderFns } from "./DeleteCourseModal.vue?vue&type=template&id=2421c773&scoped=true&"
import script from "./DeleteCourseModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2421c773",
  null
  
)

export default component.exports